import active from '../../secondary-button/light-gray/background/active';

export default active;
